import { useState } from 'react';
import { useApp } from '../../lib/app';
import { Button, PageHeader } from '../../ui/kit';
import Users from './Users';
import Roles from './Roles';
import Sites from './Sites';
import Audit from './Audit';
import Import from './Import';

const TABS = [
  ['users', 'Users'],
  ['roles', 'Roles & permissions'],
  ['sites', 'Clients / sites'],
  ['audit', 'Audit log'],
  ['import', 'Import from Smartsheet'],
] as const;

export default function Admin() {
  const { access } = useApp();
  const [tab, setTab] = useState<(typeof TABS)[number][0]>(() =>
    new URLSearchParams(window.location.search).get('tab') === 'import' ? 'import' : 'users',
  );
  return (
    <>
      <PageHeader title="Admin" sub={access?.super_admin ? 'Super Admin — you can invite people, change permissions and undo any change.' : 'Read-only for your role.'} />
      <div className="toolbar" role="tablist">
        {TABS.map(([k, l]) => (
          <Button key={k} role="tab" aria-selected={tab === k} kind={tab === k ? 'primary' : 'secondary'} onClick={() => setTab(k)}>
            {l}
          </Button>
        ))}
      </div>
      {tab === 'users' ? <Users /> : tab === 'roles' ? <Roles /> : tab === 'sites' ? <Sites /> : tab === 'import' ? <Import /> : <Audit />}
    </>
  );
}
